export type QuestionTypes = {
    question: string;
    answer: React.ReactNode;
};

const Questions: QuestionTypes[] = [
    {
        question: 'Can I receive payments through Cademy?',
        answer: (
            <>
                <p>
                    Yes - we partner with Stripe and Paypal to allow you to process online payments
                    quickly and securely. You can easily link your Stripe and Paypal accounts in
                    your Cademy admin dashboard.
                </p>
                <p>
                    Standard Stripe or PayPal processing fees apply on each transaction. Once you
                    link your Stripe or Paypal account to Cademy we will deposit payments directly
                    in your account as soon as an order is placed.
                </p>
            </>
        ),
    },
    {
        question: 'Do you offer a free plan?',
        answer: (
            <>
                <p>
                    Yes. We offer a free plan restricted to only 1 admin user. The free plan has a
                    5% platform fee on all payments, which can be absorbed or passed to customers on
                    checkout.
                </p>
                <p>
                    You can downgrade to the free plan at any time via the billing section of your
                    Cademy admin dashboard.
                </p>
            </>
        ),
    },
    {
        question: 'Are there any payment processing fees?',
        answer: (
            <>
                <p>
                    We partner with Stripe and Paypal to allow you to process online payments safely
                    and quickly, and they do charge a small fee for each payment processed.
                    Typically this fee is between 1.5% to 3.2%. Please check their websites for more
                    accurate costs.
                </p>
                <p>
                    Cademy does not charge any additional platform fees if you are on any of our
                    paid plans.
                </p>
                <p>
                    If you downgrade to our Free plan, you will be charged a 5% platform fee on all
                    payments collected through Cademy. You can choose to absorb this fee or pass it
                    on to your customers on checkout.
                </p>
            </>
        ),
    },
    {
        question: 'Do you support payments in instalments?',
        answer: (
            <>
                <p>
                    Yes - via Klarna or Paypal (Pay in 3). Simply activate Klarna or PayPal by
                    installing the relevant app in your Cademy Admin Dashboard and you are good to
                    go.
                </p>
            </>
        ),
    },
    {
        question: 'Are there cancellation fees?',
        answer: (
            <p>
                We do not charge cancellation fees. If you or your customer action a refund, the
                customer will get the full amount and you will not be charged anything for that
                order.
            </p>
        ),
    },
    {
        question: 'How do invoices work?',
        answer: (
            <>
                <p>
                    You can allow checkouts by invoice. If the customer chooses to check out by
                    invoice when enrolling, they will be sent a PDF invoice with a link where they
                    can complete the payment.
                </p>
                <p>
                    If the customer pays using the payment link in the invoice, the order will
                    automatically update in Cademy and the customer will get access to the booking
                    or course.{' '}
                </p>
                <p>
                    You can also add your bank details on the invoice, and manually update orders in
                    Cademy after a transfer is made.
                </p>
                <p>
                    Payment processing fees only apply when the customer pays the invoice by
                    Card/PayPal, so orders paid by BACS or outside of Cademy will not incur any
                    fees.
                </p>
            </>
        ),
    },
    {
        question: 'Can I import my data?',
        answer: (
            <p>
                Yes! You can import courses, events, contacts, bookings and current students. Please{' '}
                <a
                    href={`mailto:${process.env.NEXT_PUBLIC_CADEMY_SUPPORT_EMAIL_ADDRESS}?subject=Pricing question`}
                >
                    message us
                </a>{' '}
                if you need help with your imports.
            </p>
        ),
    },
    {
        question: 'Do you offer support?',
        answer: (
            <p>
                Of course! Our Edinburgh based team is here to help any time of day. Please message
                via the live chat, email us, or call anytime!
            </p>
        ),
    },
    {
        question: 'How can I cancel my plan?',
        answer: (
            <p>
                If you wish to cancel your paid plan, you can downgrade to our free plan via the
                billing section of your Cademy admin dashboard.
            </p>
        ),
    },
];

export default Questions;
